import ShareRow from "./ShareRow";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useReducer } from "react";

function ShareRows({ shares, item, setShares, setItems, setAlert }) {
  const sharesList = shares?.map((share) => (
    <ShareRow
      key={share.id}
      share={share}
      item={item}
      setShares={setShares}
      setItems={setItems}
      setAlert={setAlert}
    />
  ));

  useEffect(() => {
    // Alphetibize shares by share_user_email
    if (shares) {
      shares.sort((a, b) => {
        if (a.share_user_email < b.share_user_email) {
          return -1;
        }
        if (a.share_user_email > b.share_user_email) {
          return 1;
        }
        return 0;
      });
    }
      
  }, [shares, item]);

  return (
    <Container className="share-rows">
      <Container className="share-rows__wrapper">
        <Row>
          <Col className="share-rows__name">Email</Col>
          { item.content_type != 'e-manual' && item.tag != "membership" && item.content_type != 'e-course' && item.content_type != 'certificate-self-guided' ?  <Col className="share-rows__expiry">Expiry</Col> : '' }
          { item.content_type != 'e-manual' ?  <Col className="share-rows__status">Status</Col> : '' }
          { item.content_type != 'e-manual' && item.tag != "membership" ?  <Col className="share-rows__cert">Certificate</Col> : '' }
          <Col className="share-rows__revoke">Revoke</Col>
        </Row>
        {shares ? sharesList : "No shares found"}
      </Container>
    </Container>
  );
}

export default ShareRows;
